<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <template v-if="isAdmin">
          <el-button type="primary" :size="$store.state.buttonSize" @click="govPopup()"
            >新增机构</el-button
          >
          <RemoveButton
            type="info"
            @click="handleRemoveAll"
            :disabled="!selectionID.length"
            >批量删除</RemoveButton
          >
        </template>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="orgName" label="机构名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.orgName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="机构简称"> </el-table-column>
      <el-table-column prop="adminAreaName" label="管理区域"> </el-table-column>
      <el-table-column prop="address" label="详细地址"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="authPopup(scope.row.id)"
            >机构权限</el-button
          >
          <el-button type="text" @click="govPopup(scope.row.id)"
            >编辑</el-button
          >
          <template v-if="isAdmin">
            <el-button type="text" @click="govDel(scope.row.id)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>企业机构详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">机构名称</td>
            <td>{{ detailDate.orgName }}</td>
            <td class="list-item">机构简称</td>
            <td>{{ detailDate.shortName }}</td>
          </tr>
          <tr>
            <td class="list-item">管理员</td>
            <td>{{ detailDate.adminName }}</td>
            <td class="list-item">联系人</td>
            <td>{{ detailDate.contacts }}</td>
          </tr>
          <tr>
            <td class="list-item">管理区域</td>
            <td>{{ detailDate.adminAreaName }}</td>
            <td class="list-item">详细地址</td>
            <td>{{ detailDate.address }}</td>
          </tr>
          <tr>
            <td class="list-item">邮箱</td>
            <td>{{ detailDate.email }}</td>
            <td class="list-item">电话</td>
            <td>{{ detailDate.orgPhone }}</td>
          </tr>
          <tr>
            <td class="list-item">传真</td>
            <td>{{ detailDate.fax }}</td>
            <td class="list-item">创建时间</td>
            <td>{{ detailDate.createTime | format }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
    <!-- 机构权限 -->
    <el-dialog title="机构权限" width="50%" :visible.sync="orgAuthVisible" :close-on-click-modal="false">
      <el-tree
        :data="authTree"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="refAuthTree"
        highlight-current
        :check-strictly="true"
        :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" @click="debounceAuthSubmit">保存</el-button>
        <el-button @click="resetChecked" :size="$store.state.buttonSize">取消</el-button>
      </div>
    </el-dialog>
    <!-- 用户管理 -->
    <el-dialog title="机构用户" width="70%" :visible.sync="userTableVisible" :close-on-click-modal="false">
      <UserManagement />
    </el-dialog>
    <!-- 角色管理 -->
    <el-dialog
      title="角色管理"
      width="70%"
      :visible.sync="roleManagementVisible"
      :close-on-click-modal="false"
    >
      <RoleManagement />
    </el-dialog>
    <!-- 层级管理 -->
    <el-dialog
      title="层级管理"
      width="70%"
      :visible.sync="tierManagementVisible"
      :close-on-click-modal="false"
    >
      <TierManagement />
    </el-dialog>
    <!-- 新建/编辑机构 -->
    <el-dialog :title="title" :visible.sync="govFormVisible" :close-on-click-modal="false" center>
      <el-form
        :model="govForm"
        :size="$store.state.formSize"
        :rules="govFormRules"
        ref="refGovForm"
        label-width="120px"
      >
        <el-form-item label="管理区域：" prop="adminArea">
          <el-cascader
            :props="props"
            :placeholder="govForm.adminAreaName"
            v-model="govForm.area"
            @change="citySelect($event)"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="机构名称：" prop="orgName">
          <el-input v-model="govForm.orgName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简称：" prop="shortName">
          <el-input v-model="govForm.shortName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="管理员名称：" prop="adminName">
          <el-input v-model="govForm.adminName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="详细地址：">
          <el-input v-model="govForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="govForm.contacts" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="govForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input v-model="govForm.orgPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="传真：">
          <el-input v-model="govForm.fax" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import UserManagement from './components/UserManagement'
import RoleManagement from './components/RoleManagement'
import TierManagement from './components/TierManagement'
import {
  getGovList,
  putGovAdd,
  postGovEdit,
  getGovDetail,
  deleteGovDel,
  delGovList,
  getGovResource,
  putGovResourceAdd
} from '@/api/government'
import { getIsAdmin } from '@/api/routers'
import { getCity } from '@/api/city'
import {
  getResourceTree
} from '@/api/resource'
const createForm = () => ({
  address: '',
  adminArea: '',
  area: [],
  adminAreaName: '',
  contacts: '',
  email: '',
  fax: '',
  adminName: '',
  orgName: '',
  orgPhone: '',
  shortName: ''
})

export default {
  components: {
    UserManagement,
    RoleManagement,
    TierManagement
  },
  data() {
    return {
      isAdmin: false,
      govFormVisible: false,
      userTableVisible: false,
      orgAuthVisible: false,
      roleManagementVisible: false,
      tierManagementVisible: false,
      currentID: null,
      drawer: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      detailDate: {},
      govForm: createForm,
      govFormRules: {
        adminArea: [
          { required: true, message: '请填写管理区域', trigger: 'blur' }
        ],
        adminName: [
          { required: true, message: '请填写管理员名称', trigger: 'blur' }
        ],
        orgName: [
          { required: true, message: '请填写机构名称', trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: '请填写机构简称', trigger: 'blur' }
        ]
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data).map(item => ({
              label: item.name,
              value: item.code + ',' + item.id,
              code: item.code,
              // 判断最后一层
              leaf: item.type > 3
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      },
      loading: true,
      isDisabled: false,
      orgId: null,
      defaultProps: {
        children: 'children',
        label: 'resourceName'
      },
      authTree: [],
      selectionID: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑机构' : '新增机构'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.govSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceAuthSubmit = debounce(300, this.authSubmit)
    getIsAdmin().then(res => {
      this.isAdmin = res.data
    })
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delGovList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getGovListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.govFormVisible = false
      this.$set(this, 'govForm', createForm())
      this.$refs.refGovForm.clearValidate()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getGovListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getGovListData()
    },
    // 提交权限配置
    authSubmit() {
      const authIds = this.$refs.refAuthTree.getCheckedKeys()
      putGovResourceAdd({
        orgId: this.orgId,
        resourceIds: authIds
      }).then(res => {
        if (res.status === 1) {
          this.orgAuthVisible = false
          this.$message.success('权限配置成功')
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 打开权限配置
    authPopup(id) {
      this.$nextTick(() => {
        console.log(this.$refs)
      })
      // 获取权限
      getGovResource(id).then(res => {
        const result = res.map(_ => _.resourceId)
        this.$refs.refAuthTree.setCheckedKeys(result)
      })

      this.orgId = id
      this.orgAuthVisible = true
    },
    // 关闭权限选择
    resetChecked() {
      this.orgAuthVisible = false
      this.$refs.refAuthTree.setCheckedKeys([])
    },
    // 删除机构
    govDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteGovDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除机构成功')
              this.getGovListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改排班
    govSubmit() {
      this.$refs.refGovForm.validate(valid => {
        if (!valid) return false
        const changeGov = this.currentID ? postGovEdit : putGovAdd
        changeGov({
          address: this.govForm.address,
          adminArea: this.govForm.adminArea,
          contacts: this.govForm.contacts,
          email: this.govForm.email,
          fax: this.govForm.fax,
          adminName: this.govForm.adminName,
          orgName: this.govForm.orgName,
          orgPhone: this.govForm.orgPhone,
          shortName: this.govForm.shortName,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('修改机构成功')
              : this.$message.success('新增机构成功')
            this.govFormVisible = false
            this.getGovListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开新增/修改表单
    govPopup(id) {
      this.$set(this, 'govForm', createForm())
      const isAdd = !id
      this.govFormVisible = true

      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getGovDetail(id).then(res => {
          if (res.status === 1) {
            this.govForm.address = res.data.address
            this.govForm.adminArea = res.data.adminArea
            this.govForm.adminAreaName = res.data.adminAreaName
            this.govForm.adminName = res.data.adminName
            this.govForm.orgName = res.data.orgName
            this.govForm.shortName = res.data.shortName
            this.govForm.contacts = res.data.contacts
            this.govForm.email = res.data.email
            this.govForm.fax = res.data.fax
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    citySelect(event) {
      this.govForm.adminArea = parseInt(event.split(',')[1])
    },
    // 检索
    search() {
      this.getGovListData()
    },
    // 刷新数据表格
    refresh() {
      this.getGovListData()
      this.$message.success('数据刷新成功')
    },
    // 机构详情
    detailShow(id) {
      this.drawer = true
      getGovDetail(id).then(res => {
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 请求数据列表
    getGovListData() {
      this.loading = true
      getGovList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    // 获取资源权限列表
    getResourceTreeData() {
      getResourceTree().then(res => {
        if (res.status === 1) {
          console.log(res)
          this.authTree = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getGovListData()
    this.getResourceTreeData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
